import { Component, OnInit, Input, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { User } from '../../../models/User';
import { ProfileInstallationService } from 'src/app/services/commons/profile-installation.service';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { CommandComponent } from '../settings/command/command.component';
import { CodeComponent } from '../settings/code/code.component';
import { KeyComponent } from '../settings/key/key.component';
import { PanicCodeComponent } from '../settings/panic-code/panic-code.component';
import { GlobalVariablesService } from '../../../services/global-variables.service';
import { Installation } from '../../../models/Installation';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss'],
})
export class NewUserComponent implements OnInit {

  public newUserForm: FormGroup;
  public isServiceBusy = false;
  public currentInstallation: Installation = new Installation();
  public settings: string[] = [];
  @Input('title') title: string;
  @Input('description') description: string;
  @Input('user') user: User;
  @Input('action') action: string;
  @Input('s_ins') s_ins: number;
  @Input('userName') userName: string;
  @Input('masterUser') masterUser: boolean;
  public dataDisabled = false;
  public modalType = '';
  public supportValuesLettersNumbers = this.translate.getTranslate('MESSAGES.supportValuesLettersNumbers');
  public supportValuesTlf = this.translate.getTranslate('MESSAGES.supportValuesTlf');
  public supportValuesEmail = this.translate.getTranslate('MESSAGES.supportValuesEmail');
  public isUserMaster = false;

  constructor(private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private profileInstallationService: ProfileInstallationService,
    public gms: GlobalMethodsService,
    private zone: NgZone,
    private translate: TranslateConfigService,
    private gvs: GlobalVariablesService) {

  }


  async ngOnInit() {
    this.newUserForm = this.formBuilder.group({
      user_name: new FormControl(this.user.name, [Validators.required]),
      email: new FormControl(this.user.email, [Validators.required, Validators.email]),
      phone: new FormControl(this.user.phone, [Validators.required, Validators.pattern(/^[679]{1}[0-9]{8}$/)]),
      enableAppAccess: new FormControl(this.user.appuser_ind === 'X' ? true : false),
      enableCommand: new FormControl(this.user.remctrl_ind === 'X' ? true : false),
      enableKey: new FormControl(this.user.tag_ind === 'X' ? true : false),
      enableSecurityCode: new FormControl(this.user.key_code_ind === 'X' ? true : false),
      enablePanicCode: new FormControl(this.user.panic_code_ind === 'X' ? true : false)
    });
    await this.profileInstallationService.checkIfUserIsMaster();
    this.isUserMaster = (this.gvs.isCurrentUserMaster && this.gvs.user.userName.toLowerCase() === this.user.email.toLowerCase());
    this.currentInstallation = this.gvs.currentInstallation;
    this.settings = this.gvs.currentInstallation.settings.split('');
    this.dataDisabled = this.action === "update" ? true : false;
  }

  ionViewWillEnter(){
    if(this.action === 'update'){
      this.gms.analyticsTrackEvent('openScreen', {screenName: 'Modificar Usuario', contentGroup: 'Perfil Instalacion'});
      this.modalType = 'modify_user';
    }
    else{
      this.gms.analyticsTrackEvent('openScreen', {screenName: 'Añadir Usuario', contentGroup: 'Perfil Instalacion'});
      this.modalType = 'add_user';
    }
  }


  dismiss(confirm: boolean, result: boolean) {
    this.modalCtrl.dismiss({ confirm: confirm, result: result, action: this.action });
  }

  public async onSubmit() {
    if (this.isServiceBusy) {
      return;
    }
    this.gms.analyticsTrackEvent(this.modalType, {eventCategory: 'SICOR/Modal Usuario', eventAction: 'Accion/Guardar Crear Click'});
    if (this.newUserForm.valid) {
      const checkInternet = await this.gms.checkInternet();
      if (checkInternet) {
        this.isServiceBusy = true;
        this.newUserForm = this.gms.checkAllowedCharacters(this.newUserForm);
        let newUser: User = JSON.parse(JSON.stringify(this.user));
        newUser.name = this.newUserForm.controls.user_name.value;
        newUser.email = this.newUserForm.controls.email.value;
        newUser.phone = this.newUserForm.controls.phone.value;
        newUser.appuser_ind = this.newUserForm.controls.enableAppAccess.value === false ? '' : 'X';
        newUser.remctrl_ind = this.newUserForm.controls.enableCommand.value === false ? '' : 'X';
        newUser.remctrl_num = this.newUserForm.controls.enableCommand.value === false ? '' : newUser.remctrl_num;
        newUser.tag_ind = this.newUserForm.controls.enableKey.value === false ? '' : 'X';
        newUser.tag_num = this.newUserForm.controls.enableKey.value === false ? '' : newUser.tag_num;
        newUser.key_code = this.newUserForm.controls.enableSecurityCode.value === false ? '' : newUser.key_code;
        newUser.key_code_ind = this.newUserForm.controls.enableSecurityCode.value === false ? '' : 'X';
        newUser.panic_code = this.newUserForm.controls.enablePanicCode.value === false ? '' : newUser.panic_code;
        newUser.panic_code_ind = this.newUserForm.controls.enablePanicCode.value === false ? '' : 'X';
        const response = await this.profileInstallationService.cAppuserUserUpd(this.s_ins, newUser, this.action === 'add' ? 1 : 0, 'newUserComponent', this.userName);
        if (response === undefined) {
          if(this.action === 'update'){
            this.gms.analyticsTrackEvent('modify_user', {eventCategory: 'SICOR/Modificar Usuario', eventAction: 'Error/Modificar Usuario'});
          }else{
            this.gms.analyticsTrackEvent('add_user', {eventCategory: 'SICOR/Añadir Usuario', eventAction: 'Error/Añadir Usuario'});
          }
          return;
        }
        if (response) {
          if(this.action === 'update'){
            this.gms.analyticsTrackEvent('modify_user', {eventCategory: 'SICOR/Modificar Usuario', eventAction: 'Accion/Modificar Usuario'});
          }else{
            this.gms.analyticsTrackEvent('add_user', {eventCategory: 'SICOR/Añadir Usuario', eventAction: 'Accion/Añadir Usuario'});
          }
          await this.dismiss(true, true);
        } else {
          if(this.action === 'update'){
            this.gms.analyticsTrackEvent('modify_user', {eventCategory: 'SICOR/Modificar Usuario', eventAction: 'Error/Modificar Usuario'});
          }else{
            this.gms.analyticsTrackEvent('add_user', {eventCategory: 'SICOR/Añadir Usuario', eventAction: 'Error/Añadir Usuario'});
          }
          await this.dismiss(true, false);
        }
        this.isServiceBusy = false;
      } else {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      this.validateAllFormFields(this.newUserForm);
    }
  }

  isFieldValid(field: string) {
    return !this.newUserForm.get(field).valid && this.newUserForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(async field => {
      const control = formGroup.get(field);
      if (!control.valid){
        if (this.action === 'update'){
          this.gms.analyticsTrackEvent('form_error', {eventCategory: 'SICOR/Modificar Usuario', eventAction: 'Error/Form: Modificar Usuario', eventLabel:'Campo: ' + field});
        }else{
          this.gms.analyticsTrackEvent('form_error', {eventCategory: 'SICOR/Añadir Usuario', eventAction: 'Error/Form: Añadir Usuario', eventLabel:'Campo: ' + field});
        }
      }
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  async openCommandModal() {
    if (this.newUserForm.controls.enableCommand.value !== false) {
      if (this.checkNewUser()) {
        // open modal command
        const contentModal = await this.modalCtrl.create({
          component: CommandComponent,
          componentProps: { userName: this.userName, user: this.user, s_ins: this.s_ins },
          cssClass: ['modal-default']
        });

        contentModal.onDidDismiss().then(response => {
          this.zone.run(async () => {
            if (response.data != null && response.data.confirm) {
              this.user = response.data.user;
              if (this.user.remctrl_ind !== 'X') {
                this.newUserForm.controls.enableCommand.setValue(false);
              }
            } else {
              this.newUserForm.controls.enableCommand.setValue(false);
            }
          });
        });
        contentModal.present().then();
      } else {
        this.newUserForm.controls.enableCommand.setValue(false);
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.checkFormNewUser'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    }
  }

  async openCodeModal() {
    if (this.newUserForm.controls.enableSecurityCode.value !== false) {
      if (this.checkNewUser()) {
        // open modal command
        const contentModal = await this.modalCtrl.create({
          component: CodeComponent,
          componentProps: { userName: this.userName, user: this.user, s_ins: this.s_ins },
          cssClass: ['modal-default']
        });

        contentModal.onDidDismiss().then(response => {
          this.zone.run(async () => {
            if (response.data != null && response.data.confirm) {
              this.user = response.data.user;
              if (this.user.key_code === '') {
                this.newUserForm.controls.enableSecurityCode.setValue(false);
              }
            } else {
              this.newUserForm.controls.enableSecurityCode.setValue(false);
            }
          });
        });

        contentModal.present().then();
      } else {
        this.newUserForm.controls.enableSecurityCode.setValue(false);
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.checkFormNewUser'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    }
  }

  checkNewUser(): boolean {
    if (this.newUserForm.controls.user_name.value !== '' && this.newUserForm.controls.email.value &&
      this.newUserForm.controls.phone.value) {
      if (this.action === 'add') {
        this.user.name = this.newUserForm.controls.user_name.value;
        this.user.email = this.newUserForm.controls.email.value;
        this.user.phone = this.newUserForm.controls.phone.value;
      }
      return true;
    } else {
      return false;
    }
  }

  // Settings modal: key
  async openKeyModal() {
    if (this.newUserForm.controls.enableKey.value !== false) {
      if (this.checkNewUser()) {
        // open modal command
        const contentModal = await this.modalCtrl.create({
          component: KeyComponent,
          componentProps: { userName: this.userName, user: this.user, s_ins: this.s_ins },
          cssClass: ['modal-default']
        });

        contentModal.onDidDismiss().then(response => {
          this.zone.run(() => {
            if (response.data != null && response.data.confirm) {
              this.user = response.data.user;
              if (this.user.tag_num === '') {
                this.newUserForm.controls.enableKey.setValue(false);
              }
            } else {
              this.newUserForm.controls.enableKey.setValue(false);
            }
          });
        });

        contentModal.present().then();
      }
    }
  }

  async openPanicCodeModal() {
    if (this.newUserForm.controls.enablePanicCode.value !== false) {
      if (this.checkNewUser()) {
        // open modal command
        const contentModal = await this.modalCtrl.create({
          component: PanicCodeComponent,
          componentProps: { userName: this.userName, user: this.user, s_ins: this.s_ins },
          cssClass: ['modal-default']
        });

        contentModal.onDidDismiss().then(response => {
          this.zone.run(() => {
            if (response.data != null && response.data.confirm) {
              this.user = response.data.user;
              if (this.user.panic_code === '') {
                this.newUserForm.controls.enablePanicCode.setValue(false);
              }
            } else {
              this.newUserForm.controls.enablePanicCode.setValue(false);
            }
          });
        });

        contentModal.present().then();
      }
    }
  }

}
